import { chartColors } from './colors';
import { ILabel } from '../types.DrawIt';

export const elections: Array<number> = [2002, 2005, 2009, 2013, 2017, 2021];

export const coalitions: ILabel[] = [
    {
        text: 'Schröder II',
        values: [{ year: 2002 }, { year: 2005 }],
        colors: ['#e2001a', '#20ac00'],
        parties: ['SPD', 'Grüne']
    },
    {
        text: 'Merkel I',
        values: [{ year: 2005 }, { year: 2009 }],
        colors: ['#000', '#e2001a'],
        parties: ['Union', 'SPD']
    },
    {
        text: 'Merkel II',
        values: [{ year: 2009 }, { year: 2013 }],
        colors: ['#000', '#f4e000'],
        parties: ['Union', 'FDP']
    },
    {
        text: 'Merkel III',
        values: [{ year: 2013 }, { year: 2017 }],
        colors: ['#000', '#e2001a'],
        parties: ['Union', 'SPD']
    },
    {
        text: 'Merkel IV',
        values: [{ year: 2017 }, { year: 2021 }],
        colors: ['#000', '#e2001a'],
        parties: ['Union', 'SPD']
    }
];

export const eras: ILabel[] = [
    {
        text: 'SCHRÖDER',
        values: [{ year: 2002 }, { year: 2005 }],
        colors: [chartColors.fontSecondary]
    },
    {
        text: 'MERKEL',
        values: [{ year: 2005 }, { year: 2021 }],
        colors: [chartColors.fontSecondary]
    }
];
